import React, { useContext } from 'react'
import { LoadingContext } from '../M_Utils'

export default function M_DataGraph({ name, value, icon, color, labelColor }) {
    const ctx = useContext(LoadingContext)
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    labelColor = labelColor ? labelColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    return (
        <div className='DataGraphMainDiv'>
            <div className='DataGraphCard' style={{ border: `2px solid ${color}`}}>
                <div className='DataGraphLabels'>
                    <div className='DataGraphLabel' style={{ color: labelColor }}>
                        {name}
                    </div>
                    <div className='DataGraphSubLabel' style={{ color: labelColor }}>
                        {value}
                    </div>
                </div>
                <div className='DataGraphIcon' style={{ backgroundColor: color }}>
                    {icon}
                </div>
            </div>
        </div>
    )
}